import Link from 'next/link';
import { LightbulbOutline } from '@tac/icons';
import { Button } from '@/components/ui/button';
import { Dialog, DialogClose, DialogContent, DialogDescription, DialogTitle } from '@/components/ui/dialog';

type CompareLimitDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
};

export function CompareLimitDialog({ open, onOpenChange }: CompareLimitDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent showCloseButton={false} className="max-w-md text-center">
        <div className="flex flex-col items-center gap-6">
          <div className="flex flex-col items-center gap-4">
            <span
              className="inline-flex size-10 items-center justify-center rounded-full bg-warning-700"
              aria-hidden="true"
            >
              <LightbulbOutline className="size-5 text-white" />
            </span>
            <DialogTitle className="text-lg font-bold text-black">You can&apos;t compare more than 10 cars</DialogTitle>
            <DialogDescription className="text-lg text-greyscale-600">
              Remove one of your cars in order to add more.
            </DialogDescription>
          </div>
          <div className="flex w-full flex-col gap-4">
            <Button variant="primary" asChild>
              <Link href="/compare">Go to Comparison page</Link>
            </Button>
            <DialogClose asChild>
              <Button variant="link">Close</Button>
            </DialogClose>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
